import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../ApiUrl/meta_api";
import { RiGraduationCapLine } from "react-icons/ri";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaClock,
  FaLinkedin,
  FaInstagram,
  FaWhatsapp,
  FaYoutube,
  FaPaperPlane,
} from "react-icons/fa";
import Footer from "../../Footer/Footer";
import heroBg from "../../Img/images/BannerImage/ContactusBanner.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

const ContactPage = () => {
  const [meta, setMeta] = useState({});
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    // Directly access contactus_page from data
    const ContactusMeta = data[0]?.contactus_page;

    // Set meta state if ContactusMeta exists
    if (ContactusMeta) {
      setMeta(ContactusMeta);
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for your enquiry! We will contact you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      course: "",
      message: "",
    });
  };

  return (
    <HelmetProvider>
      <div style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "Contact Us - Berlin Technovation"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Ready to start your journey with us? We're here to help you choose the right course."
            }
          />
        </Helmet>

        {/* Hero Section */}
        <div style={{ width: "100%" }} data-aos="fade-down">
          <div
            className="position-relative"
            style={{
              backgroundImage: `url(${require("../../Img/images/BannerImage/ContactusBanner.jpg")})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              height: "350px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            ></div>

            <div
              className="position-absolute top-50 start-50 translate-middle text-center"
              style={{ zIndex: 2 }}
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <h1 className="fw-bold" style={{ color: "#008cff" }}>
                Contact Us
              </h1>
            </div>

            <div
              className="container h-100 d-flex align-items-end pb-4"
              style={{ zIndex: 2, position: "relative" }}
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <nav aria-label="breadcrumb">
                <ol
                  className="breadcrumb mb-0 px-3 py-2 rounded d-flex align-items-center"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                  }}
                >
                  <li className="breadcrumb-item d-flex align-items-center">
                    <button
                      onClick={() => navigate("/")}
                      className="btn btn-link p-0 text-decoration-none"
                      style={{
                        color: "#0663ad",
                        fontWeight: "bold",
                        background: "none",
                        border: "none",
                      }}
                    >
                      Home
                    </button>
                  </li>
                  <li
                    className="breadcrumb-item active d-flex align-items-center"
                    aria-current="page"
                    style={{ color: "#000000" }}
                  >
                    Contact Us
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Contact Details Section */}
        <section
          className="py-5 bg-light"
          style={{ overflow: "hidden" }}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <Container>
            <div className="section-header mb-3 ms-5">
              <h3
                className="text-center fw-bold mb-2"
                style={{ color: "#0663ad" }}
              >
                Contact <span className="text-black">Details</span>
              </h3>
              {/* Underline */}
              <div className="d-flex justify-content-center">
                <div className="section-divider"></div>
              </div>
            </div>

            <Row className="g-4">
              {/* Phone */}
              <Col lg={4} md={6} data-aos="fade-right" data-aos-delay="400">
                <Card className="h-100 border-0 shadow-sm text-center">
                  <Card.Body className="p-4">
                    <div
                      className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "#0663ad",
                      }}
                    >
                      <FaPhone
                        className="text-white"
                        style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    <h4 className="fw-bold mb-3">Phone</h4>
                    <p className="text-muted mb-3" style={{ height: "80px" }}>
                      +91 96004 80052
                    </p>
                    <Button
                      href="tel:+919876543210"
                      style={{
                        backgroundColor: "black",
                        borderColor: "#19194c",
                      }}
                      className="btn-sm px-4"
                    >
                      Call Now
                    </Button>
                  </Card.Body>
                </Card>
              </Col>

              {/* Email */}
              <Col lg={4} md={6} data-aos="fade-up" data-aos-delay="500">
                <Card className="h-100 border-0 shadow-sm text-center">
                  <Card.Body className="p-4">
                    <div
                      className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "#0663ad",
                      }}
                    >
                      <FaEnvelope
                        className="text-white"
                        style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    <h4 className="fw-bold mb-3">Email</h4>
                    <p className="text-muted mb-3" style={{ height: "80px" }}>
                      hr@berlintechnovation.com
                    </p>
                    <Button
                      href="mailto:hr@berlintechnovation.com"
                      style={{
                        backgroundColor: "black",
                        borderColor: "#19194c",
                      }}
                      className="btn-sm px-4"
                    >
                      Send Email
                    </Button>
                  </Card.Body>
                </Card>
              </Col>

              {/* Address */}
              <Col lg={4} md={6} data-aos="fade-up" data-aos-delay="600">
                <Card className="h-100 border-0 shadow-sm text-center">
                  <Card.Body className="p-4">
                    <div
                      className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "#0663ad",
                      }}
                    >
                      <FaMapMarkerAlt
                        className="text-white"
                        style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    <h4 className="fw-bold mb-3">Office</h4>
                    <p className="text-muted mb-3" style={{ height: "80px" }}>
                      Third Floor, Navanidhi towers, AVR roundana, Junction Main
                      Rd, Salem, Tamil Nadu 636005
                    </p>
                    <Button
                      as="a"
                      href="https://maps.app.goo.gl/xrrwp91FjXh2EMTr8"
                      target="_blank"
                      style={{
                        backgroundColor: "black",
                        borderColor: "#19194c",
                      }}
                      className="btn-sm px-4"
                    >
                      View Map
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Main Contact Form and Info */}
        <section
          className="py-5"
          style={{ overflowX: "hidden" }}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <Container>
            <Row className="g-5">
              {/* Contact Info */}
              <Col lg={6} data-aos="fade-right" data-aos-delay="300">
                <div className="mb-2">
                  <h3 className="fw-bold mb-2" style={{ color: "#0663ad" }}>
                    Get In Touch <span className="text-black">With Us</span>
                  </h3>
                  {/* Underline */}
                  <div className="section-divider mb-3 ms-5"></div>
                  <p className="text-darkD fs-6 mb-4">
                    Ready to start your journey with us? We're here to help you
                    choose the right course and answer all your questions.
                  </p>
                </div>

                <Card
                  className="border-0 shadow-sm mb-4"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <Card.Body className="p-4 d-flex">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#0663ad",
                      }}
                    >
                      <FaClock className="text-white" />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-2">Office Hours</h5>
                      <p className="text-muted mb-1">
                        Mon to Sat: 9:30 AM to 8 PM
                      </p>
                      <p className="text-muted mb-0">
                        Sunday: Online Support Only
                      </p>
                    </div>
                  </Card.Body>
                </Card>

                <div className="mb-4" data-aos="fade-up" data-aos-delay="500">
                  <h5 className="fw-bold mb-3">Follow Us</h5>
                  <div className="d-flex gap-3">
                    <button
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderColor: "#0663ad",
                        color: "#0663ad",
                      }}
                    >
                      <FaLinkedin />
                    </button>
                    <button
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderColor: "#0663ad",
                        color: "#0663ad",
                      }}
                    >
                      <FaInstagram />
                    </button>
                    <a
                      href="https://wa.me/+91 9600480052"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: "50px",
                          height: "50px",
                          borderColor: "#0663ad",
                          color: "#0663ad",
                        }}
                      >
                        {" "}
                        <FaWhatsapp />{" "}
                      </button>
                    </a>
                    <button
                      className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderColor: "#0663ad",
                        color: "#0663ad",
                      }}
                    >
                      <FaYoutube />
                    </button>
                  </div>
                </div>
              </Col>

              {/* Contact Form */}
              <Col lg={6} data-aos="fade-left" data-aos-delay="300">
                <Card className="border-0 shadow">
                  <Card.Body className="p-5">
                    <h3
                      className="fw-bold mb-4 text-center"
                      style={{ color: "#0663ad" }}
                    >
                      Support Form
                    </h3>
                    <Form onSubmit={handleSubmit}>
                      <Row className="mb-3">
                        <Col md={6} data-aos="fade-up" data-aos-delay="400">
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              <FaUser
                                className="me-2"
                                style={{ color: "0663ad" }}
                              />{" "}
                              Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              placeholder="Enter your name"
                              required
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} data-aos="fade-up" data-aos-delay="450">
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              <FaEnvelope
                                className="me-2 "
                                style={{ color: "0663ad" }}
                              />{" "}
                              Email
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Enter your email"
                              required
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6} data-aos="fade-up" data-aos-delay="500">
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              <FaPhone
                                className="me-2 "
                                style={{ color: "0663ad" }}
                              />{" "}
                              Phone
                            </Form.Label>
                            <Form.Control
                              type="tel"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Enter your phone"
                              required
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} data-aos="fade-up" data-aos-delay="550">
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Course
                            </Form.Label>
                            <Form.Select
                              name="course"
                              value={formData.course}
                              onChange={handleChange}
                              required
                              className="py-2"
                            >
                              <option value="">Select a course</option>
                              <option value="Cybersecurity">
                                Cybersecurity
                              </option>
                              <option value="Data Analytics">
                                Data Analytics
                              </option>
                              <option value="Oracle SQL">Oracle SQL</option>
                              <option value="Power BI">Power BI</option>
                              <option value="Python">Python</option>
                              <option value="Software Testing">
                                Software Testing
                              </option>
                              <option value="Tableau">Tableau</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group
                        className="mb-4"
                        data-aos="fade-up"
                        data-aos-delay="600"
                      >
                        <Form.Label className="fw-semibold">Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Tell us about your requirements..."
                          className="py-2"
                        />
                      </Form.Group>

                      <Button
                        type="submit"
                        // size="md"
                        className="w-100 fw-bold p-2"
                        style={{
                          backgroundColor: "#0663ad",
                          borderColor: "#0663ad",
                          color: "white",
                        }}
                        data-aos="zoom-in"
                        data-aos-delay="650"
                      >
                        <FaPaperPlane className="me-2" />
                        Send Message
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Map Section */}
        <section
          className="py-3 bg-light"
          style={{ overflow: "hidden" }}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <Container>
            <Row>
              <Col>
                <h3
                  className="text-center fw-bold mb-2"
                  style={{ color: "#0663ad" }}
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  Our <span className="text-dark">Location</span>
                </h3>
                {/* Centered underline */}
                <div className="d-flex justify-content-center mb-3">
                  <div className="section-divider"></div>
                </div>

                <div
                  className="ratio ratio-16x9 rounded shadow"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d125032.30502822834!2d78.0451030210887!3d11.676010156357005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3babf1523db7cd01%3A0x7008e80d55283167!2sThird%20Floor%2C%20Navanidhi%20towers%2C%20AVR%20roundana%2C%20Junction%20Main%20Rd%2C%20Salem%2C%20Tamil%20Nadu%20636005!3m2!1d11.6760219!2d78.12750489999999!5e0!3m2!1sen!2sin!4v1751448918346!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowfullscreen=""
                    loading="lazy"
                    title="Our Location"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                <div
                  className="text-center mt-4"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <h5 className="fw-bold" style={{ color: "#0663ad" }}>
                    Third Floor, Navanidhi towers, AVR roundana, Junction Main
                    Rd, Salem, Tamil Nadu 636005
                  </h5>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default ContactPage;
